import _ from 'lodash'
import { useMemo } from 'react'

import { Consultation } from '@/core/models/consultation.model'
import { Staff } from '@/core/models/staff.model'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

import { isStaff } from '@/utils/type-guards'

type UseParticipantsParams = {
  consultation?: Consultation
  participants?: Staff[]
}

export function useParticipants({ consultation, participants }: UseParticipantsParams) {
  const authUser = useAppSelector(selectAuthUser)

  const doctor = useMemo(
    () => _.trim(`${consultation?.medecin?.userInfo.surname || ''} ${consultation?.medecin?.userInfo.name || ''}`),
    [consultation]
  )

  const pds = useMemo(
    () => _.trim(`${consultation?.pds?.userInfo.surname || ''} ${consultation?.pds?.userInfo.name || ''}`),
    [consultation]
  )

  const isDoctor = useMemo(() => isStaff(authUser) && authUser?.status === 'MEDECIN', [authUser])

  const isDoctorOnline = useMemo(() => {
    if (!participants || !consultation || !consultation.medecin) return false
    return !!participants.find((participant) => participant._id === consultation?.medecin?._id)
  }, [participants, consultation])

  const isPdsOnline = useMemo(() => {
    if (!participants || !consultation) return false
    return !!participants.find((participant) => participant._id === consultation?.pds?._id)
  }, [participants, consultation])

  return {
    doctor,
    pds,
    isDoctor,
    isDoctorOnline,
    isPdsOnline,
  }
}
